
import Vue from "vue";
import OfficialHeader from "@/components/header/TheOfficialHeader.vue";
import EnterpriseFooter from "@/components/footer/TheEnterpriseFooter.vue";
import MainHeader from "@/components/header/TheMainHeader.vue";
import store from "@/store";
import { version } from "../package.json";

export default Vue.extend({
  name: "App",
  components: {
    OfficialHeader,
    EnterpriseFooter,
    MainHeader,
  },
  data: () => ({
    version: version,
  }),
  computed: {
    versionShort(): string {
      return version.substring(0, version.lastIndexOf("."));
    },
  },
  beforeCreate() {
    store.dispatch.uiFeatureModule.populateUIFeatureMapDefaults();
  },
  watch: {
    $route: function (newVal) {
      if (newVal) {
        // @ts-ignore
        this.$refs.skipLink.click();
      }
    },
  },
});
